<template>
  <v-app class='app'>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  mounted() {
    document.oncontextmenu = () => false;
  },

  watch: {
    $route: {
      handler() {
        window.scrollTo(0, 0);
      },
      immediate: true, // ページロード時にも実行
    },
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss" scoped>
.v-application--wrap {
  min-height: auto!important;
}
</style>

<style lang="scss">
body.menu-open {
  overflow: hidden !important;
}
html, body {
  font-family: $notoSans;
  // background-image: url('/img/pc_back.jpg');
  background-attachment: fixed;
  background-position: center;
  background-size: auto 120%;

  @media screen and  (max-width: $tabletWidth) {
    background-image: none;
    &:before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      // background-image: url('/img/sp_back.jpg');
      background-size: 100% auto;
      z-index: -1;
    }
  }
}
body {
  @media screen and  (max-width: $tabletWidth) {
    overflow-x: clip;
  }
}
.v-application {
  font-family: $notoSans!important;
  background: none!important;
}
// Zendesk チャットの位置を調整

/* 🔹 Zendesk チャットを完全に非表示 */
iframe[title="メッセージングウィンドウを開くボタン"],
#launcher {
  display: none !important;
}

div[aria-label^="GTCHAX's Aiのメッセージ"] {
  display: none !important;
}
</style>
